const firebaseConfig = {
    apiKey: "AIzaSyAEJDAge_tdeF_yYXXl7e6G10EMDfBBc9A",
    authDomain: "burj-al-arab-8f102.firebaseapp.com",
    projectId: "burj-al-arab-8f102",
    storageBucket: "burj-al-arab-8f102.appspot.com",
    messagingSenderId: "906236920502",
    appId: "1:906236920502:web:d79e02afd510fcf46a5c17"
};

export default firebaseConfig;